export const STATUS_TYPES = {
  0: {
    text: '抢购进行中',
    color: 'info'
  },
  1: {
    text: '抢购失败',
    color: 'danger'
  },
  2: {
    text: '抢购成功',
    color: 'success'
  }
};
